import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Results" className="border-y border-gold/30 bg-white/70" data-id="element-265" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-266" data-mp="2wvdxm2bsge6y">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-267" data-mp="2nx1x98l4e21b">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-268" data-mp="2nz4x0kc2r9j8">
              <dt className="font-display text-4xl font-black text-grape-deep sm:text-5xl" data-id="element-269" data-mp="297w33z15320a">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-270" data-mp="2dzw4zx0rs4zi">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}